type Config = {
  regulaminy: string,
  aplikacja: string,
};
let CONFIG: Config = {
  regulaminy: 'Regulamin', //['GooglePlay', 'Huawei AppGallery', 'Przelewy24']
  aplikacja: 'hotel-TEST', //['mZałoga', 'mAlert', 'mBookuj', 'mCzytnik', 'mGłosowanie', 'mGrafik', 'mKelner', 'mManager', 'mNadzorca', 'mPager', 'mSms', 'mSmsWeb']
};

// npm install typings --global
// https://stackoverflow.com/questions/50488121/typescript-add-functions-to-window-with-d-ts-file

interface WindowInterface extends Window {
  config: Config;
}

let window2config = () => { // uruchamiane w App : render()
  var config: Config = (window as unknown as WindowInterface).config || {
    // gdy nie ma public/config.js, ustawiam na parametry z kompilacji - def. wyżej
    regulaminy: CONFIG.regulaminy,
    aplikacja: CONFIG.aplikacja,
  }
  CONFIG.regulaminy = config.regulaminy;
  CONFIG.aplikacja = config.aplikacja;
}

export { window2config }
export default CONFIG;
